import React from 'react';
import type { BulkAlertCheckResponse } from '../../types';

interface StrategyAlertBannerProps {
  alerts: BulkAlertCheckResponse;
  onDismiss: () => void;
  onViewStrategy: (strategyId: number) => void;
}

export function StrategyAlertBanner({
  alerts,
  onDismiss,
  onViewStrategy,
}: StrategyAlertBannerProps) {
  if (alerts.total_new_matches === 0) return null;

  return (
    <div className="strategy-alert-banner">
      <div className="strategy-alert-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
        </svg>
      </div>
      <div className="strategy-alert-content">
        <div className="strategy-alert-title">
          {alerts.total_new_matches} new match{alerts.total_new_matches !== 1 ? 'es' : ''} found!
        </div>
        <div className="strategy-alert-strategies">
          {alerts.strategies_with_alerts.map(strategyAlert => (
            <button
              key={strategyAlert.strategy_id}
              className="strategy-alert-link"
              onClick={() => onViewStrategy(strategyAlert.strategy_id)}
            >
              {strategyAlert.strategy_name}: {strategyAlert.new_matches_count} new
            </button>
          ))}
        </div>
      </div>
      <button className="strategy-alert-dismiss" onClick={onDismiss} title="Dismiss">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
    </div>
  );
}

export default StrategyAlertBanner;
